<template>
  <div class="dados col">
    <h1 class="font-weight-bold text-uppercase" id="inicio">Meus Dados</h1>
    <hr class="linha-amarela" />
    <i class="fas fa-sign-in-alt fa-2x c-orange mr-2 mb-3"></i>
    <h4 class="text-uppercase c-orange font-weight-bold d-inline">
      Dados de Acesso
    </h4>

    <div class="row col">
      <div class="col-md-6 form-group">
        <label for="email" class="font-weight-bold">E-mail:</label><br />
        <input
          type="text"
          class="form-control"
          v-model="dados.email.value"
          :placeholder="dados.email.placeholder"
        />
      </div>

      <div class="col-md-6 form-group">
        <label class="font-weight-bold">Senha:</label><br />
        <input
          type="text"
          class="form-control"
          v-model="dados.senha.value"
          placeholder="************"
        />
      </div>
    </div>

    <hr />
    <i class="fas fa-user-circle c-orange fa-2x mr-2"></i>
    <h4 class="text-uppercase c-orange font-weight-bold d-inline">
      Dados da Conta
    </h4>
    <div class="row">
      <div class="col">
        <div class="row col-12 mt-3">
          <div class="form-group col-md-6">
            <label for="nome" class="font-weight-bold">Nome:</label><br />
            <input
              type="text"
              class="form-control"
              v-model="dados.nome.value"
              :placeholder="dados.nome.placeholder"
            />
          </div>

          <div class="form-group col-md-3">
            <label class="font-weight-bold">RG:</label><br />
            <input
              type="text"
              class="form-control"
              v-mask="'##.###.###-X'"
              v-model="dados.rg.value"
              :placeholder="dados.rg.placeholder"
            />
          </div>

          <div class="form-group col-md-3">
            <label class="font-weight-bold">CPF:</label><br />
            <input
              type="text"
              class="form-control"
              v-mask="'###.###.###-##'"
              v-model="dados.cpf.value"
              :placeholder="dados.cpf.placeholder"
            />
          </div>
        </div>

        <div class="row col-12">
          <div class="form-group col-md-6">
            <label class="font-weight-bold">Nome Fantasia:</label><br />
            <input
              type="text"
              class="form-control"
              v-model="dados.nome_fantasia.value"
              :placeholder="dados.nome_fantasia.placeholder"
            />
          </div>

          <div class="form-group col-md-6">
            <label class="font-weight-bold">CNPJ:</label><br />
            <input
              type="text"
              class="form-control"
              v-mask="'##.###.###/####-##'"
              v-model="dados.cnpj.value"
              :placeholder="dados.cnpj.placeholder"
            />
          </div>
        </div>

        <div class="row col-12 mt3">
          <div class="col-md-4">
            <label class="font-weight-bold">Whatsapp:</label>
            <input
              type="text"
              class="form-control"
              v-mask="['(##) #####-####', '(##) ####-####']"
              v-model="dados.celular.value"
              :placeholder="dados.celular.placeholder"
            />
          </div>

          <div class="form-group col-md-4">
            <label for="telefone" class="font-weight-bold"> Telefone: </label>
            <input
              type="text"
              class="form-control"
              v-mask="'(##) ####-####'"
              v-model="dados.telefone.value"
              :placeholder="dados.telefone.placeholder"
            />
          </div>

          <div class="form-group col-md-4">
            <label for="telefone2" class="font-weight-bold">
              Telefone 2:
            </label>
            <input
              type="text"
              class="form-control"
              v-mask="'(##) ####-####'"
              v-model="dados.telefone2.value"
              :placeholder="dados.telefone2.placeholder"
            />
          </div>
        </div>
      </div>
      <hr />
    </div>
    <hr />

    <i class="fa fa-map-marked-alt c-orange fa-2x mr-2 mb-3"></i>
    <h4 class="text-uppercase c-orange font-weight-bold d-inline">Endereço</h4>

    <div class="row col-12">
      <div class="col-md-4 form-group">
        <label for="" class="font-weight-bold">CEP:</label><br />
        <input
          type="text"
          v-mask="'#####-###'"
          v-model="dados.cep.value"
          @change="consultCep()"
          class="form-control"
          :placeholder="dadosUsuario.informacoes.cep"
        />
      </div>

      <div class="col-md-8 form-group">
        <label for="" class="font-weight-bold">Endereço:</label>
        <div v-if="dados.endereco.show === false">
          <input
            type="text"
            v-model="dados.endereco.value"
            disabled
            class="form-control"
          />
        </div>
      </div>

      <div class="col-md-4 form-group">
        <label for="" class="font-weight-bold">Numero: </label><br />
        <input
          type="text"
          v-model="dados.numero.value"
          class="form-control"
          :placeholder="dadosUsuario.informacoes.numero"
        />
      </div>

      <div class="col-md-8 form-group">
        <label class="font-weight-bold">Complemento:</label><br />
        <input
          type="text"
          v-model="dados.complemento.value"
          class="form-control"
          :placeholder="dadosUsuario.informacoes.complemento"
        />
      </div>

      <div class="col-md-4 form-group">
        <label for="" class="font-weight-bold">Bairro: </label><br />
        <input
          type="text"
          v-model="dados.bairro.value"
          disabled
          :placeholder="dados.bairro.value"
          class="form-control"
        />
      </div>

      <div class="col-md-4 form-group">
        <label class="font-weight-bold">Cidade:</label>
        <v-select
          v-model="dados.cidade.value"
          label="nome"
          :options="cidades"
          :placeholder="
            dadosUsuario.informacoes.cidade !== null
              ? dadosUsuario.informacoes.cidade.nome
              : ''
          "
          disabled
          class="d-inline-block"
        >
          <div slot="no-options">Não encontrou nada.</div>
        </v-select>
      </div>

      <div class="col-md-4 form-group">
        <label class="font-weight-bold">Estado:</label>
        <v-select
          v-model="dados.estado.value"
          :options="estados"
          :placeholder="
            dadosUsuario.informacoes.estado !== null
              ? dadosUsuario.informacoes.estado.uf
              : ''
          "
          disabled
          label="uf"
          class="d-inline-block"
        >
          <div slot="no-options">Não encontrou nada.</div>
        </v-select>
      </div>
    </div>
    <div class="field-atualizar mt-3 ml-3">
      <button
        @click="editarProfissional()"
        class="btn btn-success"
      >
        Salvar dados
      </button>
    </div>

    <hr />

    <div class="row col-12">
      <div class="col mt-3">
        <AcceptNotifications />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters } from "vuex";
import makeToast from "../../mixins/makeToast";
import AcceptNotifications from "../../components/AcceptNotifications";
import scrollToElement from "../../mixins/scrollToElement";

export default {
  name: "dados",
  mixins: [makeToast, scrollToElement],

  components: {
    AcceptNotifications,
  },
  data: () => ({
    dados: {
      email: {
        value: null,
        placeholder: null,
        show: false,
      },
      senha: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome_fantasia: {
        value: null,
        placeholder: null,
        show: false,
      },
      rg: {
        value: null,
        placeholder: null,
        show: false,
      },
      cpf: {
        value: null,
        placeholder: null,
        show: false,
      },
      cnpj: {
        value: null,
        placeholder: null,
        show: false,
      },
      celular: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone2: {
        value: null,
        placeholder: null,
        show: false,
      },
      endereco: {
        value: null,
        placeholder: null,
        show: false,
      },
      numero: {
        value: null,
        placeholder: null,
        show: false,
      },
      bairro: {
        value: null,
        placeholder: null,
        show: false,
      },
      cidade: {
        value: null,
        placeholder: null,
        show: false,
      },
      estado: {
        value: null,
        placeholder: null,
        show: false,
      },
      cep: {
        value: null,
        placeholder: null,
        show: false,
      },
      cidade_id: {
        value: null,
        placeholder: null,
        show: false,
      },
      complemento: {
        value: null,
        placeholder: null,
        show: false,
      },
      modificarEndNumShow: false,
      modificarBaiCidEstShow: false,
    },
  }),

  computed: {
    ...mapState(['token', 'dadosUsuario', 'estados', 'cidades']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
  },
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadEstados');
    this.scrollToElement();
  },
  mounted(){
    this.scrollToElement();
  },
  beforeMount() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }
    this.dados.email.placeholder = this.dadosUsuario.email;
    this.dados.nome.placeholder = this.dadosUsuario.informacoes.nome;
    this.dados.nome_fantasia.placeholder =this.dadosUsuario.informacoes.nome_fantasia;
    this.dados.rg.placeholder = this.dadosUsuario.rg;
    this.dados.cpf.placeholder = this.dadosUsuario.cpf;
    this.dados.cnpj.placeholder = this.dadosUsuario.cnpj;
    this.dados.celular.placeholder = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.placeholder = this.dadosUsuario.informacoes.telefone;
    this.dados.telefone2.placeholder = this.dadosUsuario.informacoes.telefone2;
    this.dados.endereco.placeholder = this.dadosUsuario.informacoes.endereco;
    this.dados.numero.placeholder = this.dadosUsuario.informacoes.numero;
    this.dados.bairro.placeholder = this.dadosUsuario.informacoes.bairro;
   
   if (this.dadosUsuario.informacoes.cidade !== null) {
      this.dados.cidade.placeholder = this.dadosUsuario.informacoes.cidade.nome;
    }
    
    if (this.dadosUsuario.informacoes.estado !== null) {
      this.dados.estado.placeholder = this.dadosUsuario.informacoes.estado.uf;
    }
   
   this.dados.cep.placeholder = this.dadosUsuario.informacoes.cep;
    this.dados.complemento.placeholder = this.dadosUsuario.informacoes.complemento;
   
    this.dados.email.value = this.dadosUsuario.email;
    this.dados.nome.value = this.dadosUsuario.informacoes.nome;
    this.dados.nome_fantasia.value = this.dadosUsuario.informacoes.nome_fantasia;
    this.dados.rg.value = this.dadosUsuario.rg;
    this.dados.cpf.value = this.dadosUsuario.cpf;
    this.dados.cnpj.value = this.dadosUsuario.cnpj;
    this.dados.celular.value = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.value = this.dadosUsuario.informacoes.telefone;
    this.dados.telefone2.value = this.dadosUsuario.informacoes.telefone2;
    this.dados.endereco.value = this.dadosUsuario.informacoes.endereco;
    this.dados.numero.value = this.dadosUsuario.informacoes.numero;
    this.dados.bairro.value = this.dadosUsuario.informacoes.bairro;
    this.dados.cidade.value = this.dadosUsuario.informacoes.cidade;
    this.dados.estado.value = this.dadosUsuario.informacoes.estado;
    this.dados.cep.value = this.dadosUsuario.informacoes.cep;
    this.dados.complemento.value = this.dadosUsuario.informacoes.complemento;
  },
  beforeUpdate() {
    if (this.$router.history.current.name === 'cadastro') {
      if (this.checkIsEmpty(this.token)) {
        this.$router.push({ name: "area-restrita" });
        
      }
    }
  },
  methods: {
    consultCep() {
      if (!this.loading && this.dados.cep.value.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('professional/consultCep', this.dados.cep.value)
          .then(async (response) => {
            this.dados.endereco.value = response.data.logradouro || null;
            this.dados.bairro.value = response.data.bairro || null;
            this.dados.cidade.value = response.data.localidade || null;
            this.dados.cidade_id.value = {
              "id": response.data.cidade_id || null,
              "nome": response.data.localidade || null,
              "estado_id": response.data.uf || null,
            }
            this.dados.estado.value = this.estados.find(estado=> 
              estado.uf === response.data.uf) || null
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }
    },

    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    modificarEndNum() {
      this.dados.endereco.show = !this.dados.endereco.show;
      this.dados.numero.show = !this.dados.numero.show;
      this.dados.modificarEndNumShow = !this.dados.modificarEndNumShow;
    },
    modificarBaiCidEst() {
      this.dados.bairro.show = !this.dados.bairro.show;
      this.dados.cidade.show = !this.dados.cidade.show;
      this.dados.estado.show = !this.dados.estado.show;
      this.dados.modificarBaiCidEstShow = !this.dados.modificarBaiCidEstShow;
    },
    editarProfissional() {
      const self = this;
      const data = {
        id: this.dadosUsuario.id,
        id_profissional: this.dadosUsuario.informacoes.id,
      };

      var cidade_id = null
      if(this.dados.cidade_id.value == null) {
        cidade_id = this.dados.cidade.value.id;
      }

      Object.assign(
      data,
        {
          email: this.dados.email.value ,
          nome: this.dados.nome.value ,
          nome_fantasia: this.dados.nome_fantasia.value,
          rg: this.dados.rg.value,
          cpf: this.dados.cpf.value,
          cnpj: this.dados.cnpj.value,
          celular: this.dados.celular.value,
          telefone: this.dados.telefone.value,
          telefone2: this.dados.telefone2.value,
          endereco: this.dados.endereco.value,
          numero: this.dados.numero.value,
          bairro: this.dados.bairro.value,
          cidade: this.dados.cidade.value,
          cidade_id: cidade_id != null ? cidade_id : this.dados.cidade_id.value.id,
          estado: this.dados.estado.value,
          cep: this.dados.cep.value,
          complemento: this.dados.complemento.value
        },
      );

      if (this.dados.senha.value !== null) {
        Object.assign(data, { password: this.dados.senha.value });
      }
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateProfissional', data)
        .then(async (response) => {
          this.makeToast('Sucesso', 'Dados atualizados com sucesso!', 'success');
          self.dados.email.show = false;
          self.dados.nome.show = false;
          self.dados.nome_fantasia.show = false;
          self.dados.rg.show = false;
          self.dados.cpf.show = false;
          self.dados.cnpj.show = false;
          self.dados.celular.show = false;
          self.dados.telefone.show = false;
          self.dados.endereco.show = false;
          self.dados.numero.show = false;
          self.dados.bairro.show = false;
          self.dados.cidade.show = false;
          self.dados.estado.show = false;
          self.dados.cep.show = false;
          self.dados.complemento.show = false;
          self.dados.senha.show = false;
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao atualizar!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },
  },
};
</script>
